






























































































































































































































































import { Component, PropSync, Ref, Vue, Watch } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import DateField from "@/components/misc/DateField.vue";
import TimeField from "@/components/misc/TimeField.vue";
import NumericInput from "@/components/misc/NumericInput.vue";
import FormalCurrencyDisplay from "@/components/misc/FormalCurrencyDisplay.vue";
import { DataOptions, DataTableHeader } from "vuetify";
import { formatOrderbyArray } from "@/shared/sortHelperFunctions";
import { FinancialSettingsType } from "@/store/modules/financial";
import { Currency } from "@/shared/models/currency";
import { saveFile } from "@/shared/saveFile";
import * as _ from "lodash";
import { PaymentMeansEnum } from "@/shared/models/enums.type";
import { JwtClaims } from "@/store/modules/auth";
import { BusinessUnit } from "@/shared/models/businessUnit";

export type CashiersReportPaymentViewModel = {
  reservationId?: number;
  amount: number;
  paymentMeansId: number;
  paymentMeans: string;
  paymentMeanBaseId: number;
  cardType: string;
  paymentDate: string;
  currencyCode: string;
  isOnlinePayment: boolean;

  financialDocuments: CashiersReportFinancialDocumentPaymentViewModel[];
};

export type CashiersReportFinancialDocumentPaymentViewModel = {
  documentNumber: string;
  documentIdentifier: string;
  documentInternalIdentifier: string;
  assignedAmount: number;
};

@Component({
  components: {
    DateField,
    TimeField,
    NumericInput,
    FormalCurrencyDisplay,
  },
})
export default class CahiersReport extends Vue {
  @PropSync("open", { default: false }) isOpen?: boolean;
  closeModal() {
    this.$emit("reload");
    this.isOpen = false;
  }
  @Watch("isOpen")
  openWatch(fresh: boolean, old: boolean) {
    if (fresh && !old) {
      this.load();
    }
  }

  // prettier-ignore
  @Getter("financial/settings") storedSettings?: FinancialSettingsType;
  @Action("financial/refreshModel") refreshSettings?: () => Promise<void>;

  @Getter("appParams/formalCurrency") formalCurrency?: Currency;
  @Action("codebooks/refreshCurrencies")
  refreshCurrencies?: () => Promise<void>;
  @Getter("codebooks/currencies") currencies?: Currency[];

  @Getter("language/language") language?: string;

  @Getter("appParams/cashRegisterFeatureFlag")
  cashRegisterFeature?: boolean;

  @Getter("businessUnit/activeBusinessUnit") activeBusinessUnit?: BusinessUnit;

  created() {
    if (!this.storedSettings && this.refreshSettings) {
      this.refreshSettings();
    }

    if ((this.currencies?.length ?? 0) === 0 && this.refreshCurrencies) {
      this.refreshCurrencies();
    }
  }

  @Watch("storedSettings", { deep: true, immediate: true })
  financialSettingsWatch() {
    this.filters.startingAmount =
      this.storedSettings?.cashiersReportStartingAmount ?? null;
  }

  get cashBalance() {
    const cash = this.list
      .filter((x) => x.paymentMeansId === PaymentMeansEnum.Novcanice)
      .reduce((sum, r) => sum + r.amount, 0);

    return (this.filters.startingAmount ?? 0) + cash;
  }

  get setsFiscalAsMain() {
    return this.storedSettings?.setFiscalNumberAsMain ?? false;
  }

  get correctCurrencyToDisplay() {
    return this.storedSettings?.historicCurrency &&
      this.list.every(
        (x) =>
          x.currencyCode === this.storedSettings?.historicCurrency.isoCode &&
          this.storedSettings?.historicCurrencyEndDate &&
          new Date(x.paymentDate).getFullYear() <
            new Date(this.storedSettings?.historicCurrencyEndDate).getFullYear()
      )
      ? this.storedSettings?.historicCurrency.isoCode
      : this.formalCurrency?.isoCode;
  }

  get cashTotal() {
    return (
      this.list
        ?.filter((x) => x.paymentMeansId === PaymentMeansEnum.Novcanice)
        .reduce((sum, r) => sum + r.amount, 0) ?? 0
    );
  }

  get transactionAccountsTotal() {
    return (
      this.list
        ?.filter(
          (x) => x.paymentMeansId === PaymentMeansEnum.TransakcijskiRacun
        )
        .reduce((sum, r) => sum + r.amount, 0) ?? 0
    );
  }

  get onlineTransactionsTotal() {
    return (
      this.list
        ?.filter((x) => x.isOnlinePayment)
        .reduce((sum, r) => sum + r.amount, 0) ?? 0
    );
  }

  get cardsTotal() {
    return (
      this.list
        ?.filter(
          (x) =>
            (x.paymentMeansId === PaymentMeansEnum.KreditnaKartica ||
              x.paymentMeansId === PaymentMeansEnum.BankovnaKartica) &&
            !x.isOnlinePayment
        )
        .reduce((sum, r) => sum + r.amount, 0) ?? 0
    );
  }

  get otherTotal() {
    return (
      this.list
        ?.filter(
          (x) =>
            x.paymentMeansId !== PaymentMeansEnum.Novcanice &&
            x.paymentMeansId !== PaymentMeansEnum.BankovnaKartica &&
            x.paymentMeansId !== PaymentMeansEnum.KreditnaKartica &&
            x.paymentMeansId !== PaymentMeansEnum.OnlineServisZaPlacanje &&
            x.paymentMeansId !== PaymentMeansEnum.TransakcijskiRacun
        )
        .reduce((sum, r) => sum + r.amount, 0) ?? 0
    );
  }

  get total() {
    return this.list?.reduce((sum, r) => sum + r.amount, 0) ?? 0;
  }

  headers: DataTableHeader[] = [];

  @Getter("auth/claims") claims?: JwtClaims;
  @Watch("claims.roles", { immediate: true })
  rolesWatch() {
    this.headers = [
      {
        text: "CashiersReport.ReservationId",
        value: "reservationId",
      },
      {
        text: "CashiersReport.DocumentNumber",
        value: "documentIdentifier",
        sortable: false,
        //          text: "CashiersReport.DocumentNumber",
        //  value: this.setsFiscalAsMain
        //    ? "documentIdentifier"
        //    : "documentInternalIdentifier",
      },
      {
        text: "CashiersReport.Amount",
        value: "amount",
      },
      {
        text: "CashiersReport.PaymentMeans",
        value: "paymentMeans",
      },
      {
        text: "CashiersReport.PaymentDate",
        value: "paymentDate",
      },
    ];
  }

  get translatedHeaders() {
    return this.headers.map((x) => ({ ...x, text: this.$t(x.text) }));
  }

  tab = 0;
  isFormValid = false;
  @Ref("form") form?: any;
  filters = {
    dates: [
      new Date().toISOString().substring(0, 10),
      new Date().toISOString().substring(0, 10),
    ] as string[],
    timeFrom: "00:00" as string | null,
    timeTo: "23:59" as string | null,
    startingAmount:
      this.storedSettings?.cashiersReportStartingAmount ??
      (null as number | null),
  };
  @Watch("filters", { deep: true, immediate: true })
  watchFilters() {
    this.options.page = 1;
    this.debouncedLoad();
  }

  get filtersForRequest() {
    return {
      dateFrom: this.filters.dates.length === 2 ? this.filters.dates[0] : null,
      dateTo: this.filters.dates.length === 2 ? this.filters.dates[1] : null,
      timeFrom: this.filters.timeFrom,
      timeTo: this.filters.timeTo,
      startingAmount: this.filters.startingAmount,
    };
  }

  options: DataOptions = {
    page: 1,
    itemsPerPage: 15,
    sortBy: ["paymentDate"],
    sortDesc: [],
    groupBy: [],
    groupDesc: [],
    multiSort: false,
    mustSort: true,
  };

  loading = false;
  list = [] as CashiersReportPaymentViewModel[];

  get filteredList() {
    switch (this.tab) {
      case 0:
        return this.list.filter(
          (x) => x.paymentMeansId === PaymentMeansEnum.Novcanice
        );
      case 1:
        return this.list.filter(
          (x) => x.paymentMeansId === PaymentMeansEnum.TransakcijskiRacun
        );
      case 2:
        return this.list.filter(
          (x) =>
            (x.paymentMeansId === PaymentMeansEnum.KreditnaKartica ||
              x.paymentMeansId === PaymentMeansEnum.BankovnaKartica) &&
            !x.isOnlinePayment
        );
      case 3:
        return this.list.filter((x) => x.isOnlinePayment);
      case 4:
        return this.list.filter(
          (x) =>
            x.paymentMeansId !== PaymentMeansEnum.Novcanice &&
            x.paymentMeansId !== PaymentMeansEnum.BankovnaKartica &&
            x.paymentMeansId !== PaymentMeansEnum.KreditnaKartica &&
            x.paymentMeansId !== PaymentMeansEnum.OnlineServisZaPlacanje &&
            x.paymentMeansId !== PaymentMeansEnum.TransakcijskiRacun
        );
      default:
        return this.list;
    }
  }

  get cardTypesSummary() {
    const results: string[] = [];

    const cardPayments = this.list.filter(
      (x) =>
        (x.paymentMeansId === PaymentMeansEnum.KreditnaKartica ||
          x.paymentMeansId === PaymentMeansEnum.BankovnaKartica) &&
        !x.isOnlinePayment
    );
    const grouped = _.groupBy(cardPayments, (x) => x.cardType);

    for (const group in grouped) {
      const isoCode = grouped[group][0].currencyCode;
      const groupTotal = grouped[group].reduce((sum, x) => sum + x.amount, 0);
      results.push(
        `${group} - ${this.$n(groupTotal, {
          style: "currency",
          currency: isoCode,
          currencyDisplay: "code",
        })}`
      );
    }

    if (results.length === 0) {
      results.push(this.$t("CashiersReport.NoCardPayments").toString());
    }

    return results;
  }

  get onlineTransactionSummary() {
    const results: string[] = [];

    const onlineTransactions = this.list.filter((x) => x.isOnlinePayment);
    const grouped = _.groupBy(onlineTransactions, (x) => x.cardType);

    for (const group in grouped) {
      const isoCode = grouped[group][0].currencyCode;
      const groupTotal = grouped[group].reduce((sum, x) => sum + x.amount, 0);
      results.push(
        `${group} - ${this.$n(groupTotal, {
          style: "currency",
          currency: isoCode,
          currencyDisplay: "code",
        })}`
      );
    }

    if (results.length === 0) {
      results.push(this.$t("CashiersReport.NoCardPayments").toString());
    }

    return results;
  }

  debouncedLoad = _.debounce(this.load, 500);
  async load(): Promise<CashiersReportPaymentViewModel[]> {
    if (!this.isFormValid || !this.isOpen) {
      this.list = [];

      return this.list;
    }

    this.loading = true;
    return this.axios
      .get<CashiersReportPaymentViewModel[]>("/payments/GetCashiersReport", {
        params: this.queryParams,
      })
      .then((res) => {
        this.list = res.data;

        return this.list;
      })
      .finally(() => {
        this.scrollToTop();
        this.loading = false;
      });
  }

  get queryParams() {
    return {
      $skip: this.options.itemsPerPage * (this.options.page - 1),
      $top: this.options.itemsPerPage,
      $orderby: formatOrderbyArray(
        this.options.sortBy,
        this.options.sortDesc.map((x) => !x)
      ),
      $count: true,
      ...this.filtersForRequest,
    };
  }

  scrollToTop() {
    let scrollableWrapper: Element | null = null;

    if (this.$refs.dataTable instanceof Vue) {
      scrollableWrapper = (this.$refs.dataTable as Vue).$el.querySelector(
        ".v-data-table__wrapper"
      );
    } else if (this.$refs.dataTable instanceof Element) {
      scrollableWrapper = (this.$refs.dataTable as Element).querySelector(
        ".v-data-table__wrapper"
      );
    }

    if (scrollableWrapper) {
      scrollableWrapper.scrollTop = 0;
    }
  }

  get rules() {
    return {
      required: (value: any) => !!value || this.$t("Validation.Required"),
      required0Allowed: (value: any) =>
        !!value || value === 0 || this.$t("Validation.Required"),
      requiredDateRange: (value: string[]) =>
        value.length === 2 || this.$t("Validation.RequiredDateRange"),
    };
  }

  exporting = false;
  async downloadExport() {
    this.exporting = true;

    const request = {
      businessUnitId: this.activeBusinessUnit?.id,
      dateFrom: this.filtersForRequest.dateFrom,
      dateTo: this.filtersForRequest.dateTo,
      timeFrom: this.filtersForRequest.timeFrom,
      timeTo: this.filtersForRequest.timeTo,
      startingAmount: this.filtersForRequest.startingAmount,
      cultureCode: this.language ?? "hr-HR",
    };

    await this.$http
      .get("/payments/ExportCashiersReport", {
        params: request,
        responseType: "blob",
      })
      .then((res) => {
        const groups = /filename=(?<filename>[^;]+);/.exec(
          res.headers["content-disposition"]
        )?.groups;

        saveFile(res.data, groups?.filename ?? `CashiersReport.pdf`);
      })
      .finally(() => {
        this.exporting = false;
      });
  }
}
